module.exports = __webpack_public_path__ + "img/cappuccino.a966b6ac.jpg";